/*
* NCPE is a singleton to track user click events,then batch sync the logs to cloud.
* Dependency:None.
* todo list:
* 1.actionName :nodename-btnname
* 2.logQuene tunning(variable or sessionStorage)(LogQuene,LogQuene2)
* 3.how to get userid.$ncpe.userid=??
* 4.how to configure projectcode(as well as other parameters) of nlink easily--a configure file is the best.($ncpe.projectcode=???)
* (3,4 should get be inited by  login and logout.)
* 5.register event handle for window close.(to call $NCPE.commit())
*/
/*
    * quene based on sessionStorage.
    * if the application open more than one window, sessionStorage is not suitable.
     */
import { setStore, getStore } from './storageUtils';
function LogQueneocal() {
    this.getQuene = () => getStore("pelog") || [];
    this.isEmpty = () => {
        return this.getQuene().length == 0;
    };
    this.push = log => {
        let quene = this.getQuene();
        quene.push(log);
        setStore("pelog", quene);
    };
    this.poll = () => {
        let writeQuene = this.getQuene().slice(0);
        localStorage.removeItem("pelog");
        return writeQuene;
    };
    this.size = () => this.getQuene().length;
}
/*
                * quene based on sessionStorage.
                * if the application open more than one window, sessionStorage is not suitable.
                 */
function LogQuene() {
    this.getQuene = () => JSON.parse(sessionStorage.getItem("pelog")) || [];
    this.isEmpty = () => {
        return this.getQuene().length == 0;
    };
    this.push = log => {
        let quene = this.getQuene();
        quene.push(log);
        sessionStorage.setItem("pelog", JSON.stringify(quene));
    };
    this.poll = () => {
        let writeQuene = this.getQuene().slice(0);
        sessionStorage.removeItem("pelog");
        return writeQuene;
    };
    this.size = () => this.getQuene().length;
}
var LogQuene_local = new LogQueneocal();
var logQuene = new LogQuene();
/*
        * gloabal variable.
        */
if (!$NCPE) {
    var $NCPE = new NCPE();
    if (!LogQuene_local.isEmpty()) {
        $NCPE.commit_local();
    }
    /*
            * sync everty half an hour.
            */
    setInterval($NCPE.commit, 15 * 60 * 1000);
}
let curAction = "";

// let allRemote = new Array();
//remotecall times.
let remotecalls = 0;

function NCPE() {
    let isLog = true;
	
	let count = 0;

    if (typeof Storage == "undefined") {
        //session storage is not supported by the browser.
        isLog = false;
    }

    // console.log('$ncpe is supported:' + isLog);
    let currevent = {};
    /*init env,userid,can be init $ncpe['userid']=??,$ncpe['projectcode']=??*/
    this.userid = "nctest";
    this.projectcode = "nccloud";
    this.lastAction = "";

    // 改为通过 window.peData.nlinkUrl 进行传入
    // const NLINKURL = 'http://123.103.9.190:17752';
    // const NLINKURL = "http://127.0.0.1:7760/";
    /* init context*/
    let context = this;

    //record and hanle log entries.try if it would work while let logQuene=new LogQuene2()
    // let logQuene = new LogQuene();
    let failTimes = 0;
    //Ajax请求黑名单列表；
    let blackList =  [];
    // 从 window.peData.projectCode 中获取黑名单
    if (window.peData && window.peData.projectCode) {
        const parts = window.peData.projectCode.split('#');
        if (parts.length > 1) {
            blackList = parts[parts.length - 1].split(';');
        }
    }
    /*
            * funcname: the top layer of the click servs.eg.凭证-保存
            */
    function PE_TouchPoint(actionName) {
        /*
                *funcname is related to page context.
                *this need to parsed from actionName,or set property seperately.
                *default use actionName,but it should be refined later.
                */
        this.funName = encodeURI(window.peData.nodeName, "UTF-8");
        /*
                *busiAction is the clicked element value .
                */
        this.busiAction = encodeURI(actionName, "UTF-8");

        this.startTs = Date.now();
        this.endTs = Date.now();
         // 新增 request 属性，用于存放 ajax 请求对象
         this.request = [];
        this.toString = () => {
            var COSTTIME = this.endTs - this.startTs;
            if(window.peData.projectCode != null){
                if(window.peData.projectCode.includes("&&")){
                    this.projectcode = window.peData.projectCode.split("&&")[0];
                }else{
                    this.projectcode = window.peData.projectCode
                }
                const parts = this.projectcode.split('#');
                if (parts.length === 6) {
                    // 截取最后一个 # 前面的内容
                    const lastIndex = this.projectcode.lastIndexOf('#');
                    this.projectcode =  this.projectcode.slice(0, lastIndex);
                }
            }
            let requestStrList = this.request.map(req => `fun:${req.fun};starttime:${req.starttime};endtime:${req.endtime};costtime:${req.costtime}##`);
            return (
                "projectcode:" +
                this.projectcode +
                ";nodename:" +
                this.funName +
                ";busiaction:" +
                this.busiAction +
                ";costtime:" +
                COSTTIME +
                ";userid:" +
                window.peData.userID +
                ";opts:" +
                this.startTs +
                ";dr:" +
                remotecalls +
                ";nodeCode:" +
                window.peData.nodeCode +
                ";all_resq:" +
                requestStrList.join('')
            );
        };
    }

    /*
           * quene based on Array.
           */
    function LogQuene2() {
        this.logArr = [];
        this.isEmpty = () => {
            return this.logArr.length == 0;
        };
        this.push = log => {
            this.logArr.push(log);
        };
        this.poll = () => {
            let writeQuene = this.logArr.slice(0);
            this.logArr.length = 0;
            return writeQuene;
        };
        this.size = () => this.logArr.length;
    }
    /*
            * add touchpoint to the logQuene.
            * when log entries is up to 20,
            * then sync to cloud by batch.
            */
    function addLog(touchPoint) {
        if (!isLog) {
            return;
        }
        if (touchPoint == null || touchPoint == undefined) {
            return;
        }
        logQuene.push(touchPoint.toString());
        // console.log(touchPoint.toString());
        // console.log('quene length:' + logQuene.size());
        if (logQuene.size() >= 10) {
            this.commit();
        }
    }

    /*
            *sync data to cloud.
            *it should be called when logout as not to lose any data.
            */
    this.commit = function() {
        if (!isLog) {
			//未开启pe的情况下，判断是否为25日，只同步license检测云端
			if(is25thDay()){
				//如25日，只同步license检测云端
				//增加一层校验，避免25日重启，url为空得情况，因为更新是在24日
				if(window.peData.nlinkUrl != null){
					if(count === 0){
						sendData(window.peData.nlinkUrl);
						count++;
					}
					if(count === 1){
						requireSyncMem();
						count++;
					}
					sessionStorage.removeItem("pelog");
					localStorage.removeItem("pelog");
					if(!logQuene.isEmpty()) {
						logQuene.poll();
					}
					if(!writeQuene.isEmpty()){
						writeQuene.poll();
					}
				}
			}else{
				 return;
			}
        }
        if (logQuene.isEmpty()) {
            return;
        }
		//开启pe的情况下，既要满足同步pe，又要满足同步license检测云端
		if(is25thDay()){
			//如25日，同步一次license检测云端，pe正常同步
			let url = window.peData.nlinkUrl;
			if(url!=null){
				//判断是否为pe地址和云端地址拼接，如是，表示既开启pe,又开启前端传项目信息
				if(url.includes("&&")){
					let nlinkUrl = url.split("&&")[1];
					let peUrl = url.split("&&")[0];
					sendDataToPe(peUrl,logQuene.poll());
					if(count === 0){
						sendData(nlinkUrl);
						count++;
					}
					if(count === 1){
						requireSyncMem();
						count++;
					}
				//只开启pe,不开启前端传项目信息，只上传pe相关信息
				}else if(url.includes("$$")){
					let peUrl = url.split("$$")[0];
					sendDataToPe(peUrl,logQuene.poll());
				//既不开启pe,也不开启前端传项目信息，直接结束
				}else if(url === null){
					return;
				//只开启前端传项目信息
				}else{
					//同步一次license检测云端后，恢复正常只同步pe；
					if(count === 0){
						sendData(url);
						count++;
					}
					if(count === 1){
						requireSyncMem();
						count++;
					}
					sessionStorage.removeItem("pelog");
					localStorage.removeItem("pelog");
					if(!logQuene.isEmpty()) {
						logQuene.poll();
					}
					if(!writeQuene.isEmpty()){
						writeQuene.poll();
					}
				}
			}else{
				return;
			}
			
		}else{
			//非25日，只同步Pe
			let url = window.peData.nlinkUrl;
            if(url != null){
                if(url.includes("$$")){
                    url = url.split("$$")[0];
                }
                sendDataToPe(url,logQuene.poll());
                count = 0;
            }else{
                return;
            }
		
		}
    };
    /*
            *sync data to cloud.
            *it should be called when logout as not to lose any data.
            */
    this.commit_local = function() {
        if (!isLog) {
			//未开启pe的情况下，判断是否为25日，只同步license检测云端
			if(is25thDay()){
				//如25日，只同步license检测云端
				//增加一层校验，避免25日重启，url为空得情况，因为更新是在24日
				if(window.peData.nlinkUrl != null){
					if(count === 0){
						sendData(window.peData.nlinkUrl);
						count++;
					}
					if(count === 1){
						requireSyncMem();
						count++;
					}
					sessionStorage.removeItem("pelog");
					localStorage.removeItem("pelog");
					if(!logQuene.isEmpty()) {
						logQuene.poll();
					}
					if(!writeQuene.isEmpty()){
						writeQuene.poll();
					}
				}
			}else{
				 return;
			}
        }
        if (LogQuene_local.isEmpty()) {
            return;
        }
        let writeQuene = LogQuene_local.poll();
		//开启pe的情况下，既要满足同步pe，又要满足同步license检测云端
		if(is25thDay()){
			//如25日，同步一次license检测云端，pe正常同步
			let url = window.peData.nlinkUrl;
			if(url!=null){
				//判断是否为pe地址和云端地址拼接，如是，表示既开启pe,又开启前端传项目信息
				if(url.includes("&&")){
					let nlinkUrl = url.split("&&")[1];
					let peUrl = url.split("&&")[0];
					sendDataToPe(peUrl,writeQuene);
					if(count === 0){
						sendData(nlinkUrl);
						count++;
					}
					if(count === 1){
						requireSyncMem();
						count++;
					}
				//只开启pe,不开启前端传项目信息，只上传pe相关信息
				}else if(url.includes("$$")){
					let peUrl = url.split("$$")[0];
					sendDataToPe(peUrl,writeQuene);
				//既不开启pe,也不开启前端传项目信息，直接结束
				}else if(url === null){
					return;
				//只开启前端传项目信息
				}else{
					//同步一次license检测云端后，恢复正常只同步pe；
					if(count === 0){
						sendData(url);
						count++;
					}
					if(count === 1){
						requireSyncMem();
						count++;
					}
					sessionStorage.removeItem("pelog");
					localStorage.removeItem("pelog");
					if(!logQuene.isEmpty()) {
						logQuene.poll();
					}
					if(!writeQuene.isEmpty()){
						writeQuene.poll();
					}
				}
			}else{
				return;
			}
			
		}else{
			//非25日，只同步Pe
			let url = window.peData.nlinkUrl;
            if(url!=null){
                if(url.includes("$$")){
                    url = url.split("$$")[0];
                    sendDataToPe(url,writeQuene);
                    count = 0;
                }
               
            }else{
                return;
            }
			
		}
    };


    //发送数据给pe
    function sendDataToPe(peUrl, writeQuene){
        try {
            //batch sync to cloud
            let xhttp = new XMLHttpRequest();
            xhttp.open("POST", peUrl, true);
            /*stop logging in case of network error.*/
            xhttp.onerror = () => {
                // console.log('commit pe error,failtimes=' + failTimes);
                failTimes++;
                if (failTimes > 3) {
                    isLog = false;
                    // console.log('network is error,set islog=false');
                }
            };
            xhttp.onload = () => {
                // console.log('sync over!');
            };
            /*content type should be cloud*/
            xhttp.setRequestHeader(
                "Content-type",
                "application/x-www-form-urlencoded"
            );
            xhttp.send("type=nc&log=" + writeQuene.join("\n"));
        } catch (error) {
            //throw new Error(error);
            console.log("sendDataToPe error");
        }
    }

    // 检查当前日期是否为25日
    function is25thDay() {
        const now = new Date();
        return (
            now.getDate() === 25  // 日期是25日
        );
    }

    //发送数据给云端检测
    function sendData(nlinkUrl) {
        try{
            //batch sync to cloud
            let xhttp = new XMLHttpRequest();
            xhttp.open("POST", nlinkUrl, true);
            /*stop logging in case of network error.*/
            xhttp.onerror = () => {
                // console.log('commit pe error,failtimes=' + failTimes);
                failTimes++;
                if (failTimes > 3) {
                    isLog = false;
                    // console.log('network is error,set islog=false');
                }
            };
            xhttp.onload = () => {
                // console.log('sync over!');
            };
            /*content type should be cloud*/
            xhttp.setRequestHeader(
                "Content-type",
                "application/x-www-form-urlencoded"
            );
            var code = window.peData.projectCode;
            if(code != null){
                if(code.includes("&&")){
                    code = code.split("&&")[1];
                }
            }
            let datas =  "projectcode:" +
                    code + 
                    ";nodename:checkLicense" +
                    ";busiaction:checkLicense" +
                    ";costtime:0" +
                    ";userid:DEFAULE" +
                    ";opts:0" +
                    ";dr:0" +
                    ";nodeCode:checkLicense"
            xhttp.send("type=nc&log=" + datas);
        }catch(error) {
            //throw new Error(error);
            console.log("sendData error");
        }
        
    }


    //同步后端，修改内存中code和URL值还原
    function requireSyncMem(){
        try{
            // 创建 XMLHttpRequest 对象
            var xhr = new XMLHttpRequest();

            // 定义请求的类型、URL 以及是否异步
            xhr.open("GET", "/service/requireSyncMem", true);

            // 设置请求完成后的回调函数
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    // 解析返回的 JSON 数据
                    var response = JSON.parse(xhr.responseText);

                    // 将 projectcode 和 url 存储到 window 对象中
                    var result = response.result;
                
                } else {
                    console.error("Request failed with status: " + xhr.status);
                }
            };

            // 处理网络错误
            xhr.onerror = function () {
                console.error("Network error occurred");
            };

            // 发送请求
            xhr.send();
        }catch(error) {
            //throw new Error(error);
            console.log("requireSyncMem error");
        }
    }




    /*
            *button is clicked
            */
    this.startAction = function(actionName) {
        //判断是否有没提交的业务动作
        if (curAction != ""){
            this.endAction(curAction);
        } 
        this.lastAction = window.peData.nodeName + "-" + actionName;
        curAction = actionName;
        // allRemote = new Array();
        //reset remotecall times.
        remotecalls = 0;
        if (
            window.peData.projectCode == null ||
            window.peData.projectCode == "undefined" ||
            window.peData.nlinkUrl == null ||
            window.peData.nlinkUrl == "undefined" ||
            window.peData.nlinkUrl == ""
        ) {
            isLog = false;
            return;
        }
        if (actionName == null || actionName == "undefined") {
            return;
        }
        currevent[actionName] = new PE_TouchPoint(actionName);
    };
    /*
            *the event is handled over
            */
    this.endAction = function(actionName) {
        if (actionName == null || actionName == "undefined") {
            return;
        }
        if (currevent[actionName] != null) {
            // currevent[actionName].endTs = Date.now();
            addLog.call(this, currevent[actionName]);
            currevent[actionName] = null;
        }
        curAction = "";
    };
    /*
            * proxy of the event handler.
            * actioinName:凭证-保存
            */
    this.proxy = function(func, context, actionName) {
        if (func) {
            return function() {
                $NCPE.startAction(actionName);
                try {
                    func.call(context, ...arguments);
                } finally {
                    // $NCPE.endAction(actionName);
                }
            };
        }
    };

    /*
            *another way to proxy event handler.
            */
    this.proxyAction = (func, context, actionName) => (...arg) => {
        if (func) {
            $NCPE.startAction(actionName);
            try {
                func.call(context, ...arg);
            } finally {
                // $NCPE.endAction(actionName);
            }
        }
        // 判断是否为注销
        if (arg && arg[0] && arg[0].logout) {
            //判断是否有没提交的业务动作
            if (curAction != "") {
                this.endAction(curAction);
            }
            LogQuene_local.push(logQuene.getQuene());
            sessionStorage.removeItem("pelog");
            $NCPE.commit_local();
        }
    };

    /**加入远程调用url */
    this.startAjax = function(url) {
        if (url) {
            url = url.slice(1);
        }
        if (curAction == null || curAction == "undefined" || curAction == "") {
            return;
        } 
        let currentEvent = currevent[curAction];
        if (currentEvent) {
            // 检查请求是否在黑名单中;
            if(!blackList.includes(url)){
                let starttime = Date.now();
                currentEvent.request.push({
                    fun: url,
                    starttime: starttime,
                    endtime: null,
                    costtime: null
                });
            }
        }
        // else {
        //     allRemote.push(url);
        // }
        remotecalls++;
    };

    //Array.prototype.indexOf = function(val) {
    //    for (var i = 0; i < this.length; i++) {
    //        if (this[i] == val) return i;
    //    }
    //    return -1;
    //};

   // Array.prototype.remove = function(val) {
   //    var index = this.indexOf(val);
   //    if (index > -1) {
   //        this.splice(index, 1);
   //    }
   //};

    /**删除远程调用 */
    this.endAjax = function(url) {
        if (url) {
            url = url.slice(1);
        }
        // if (allRemote.length == 0 || curAction == "") return;
        if (curAction == ""){
            return;
        } 
        if (currevent[curAction] != null) {
            let currentEvent = currevent[curAction];
            //放入request中，用于后面云端分析使用；
            let request = currentEvent.request.find(req => req.fun === url);
            let endtime = Date.now();
            if (request) {
                request.endtime = endtime;
                request.costtime = endtime - request.starttime;
            }
            // 检查请求是否在黑名单中,如不在，直接设置结束时间
            if (!blackList.includes(url)) {
                currentEvent.endTs = endtime;
            }
        }
        // allRemote.remove(url);
        //远程调用数组为空，调用endAction()
        // if (allRemote.length == 0) {
        //     $NCPE.endAction(curAction);
        // }
    };
}
window.addEventListener("beforeunload", function() {
    //判断是否有没提交的业务动作
    if (curAction != "") {
        $NCPE.endAction(curAction);
    }
    if (!logQuene.isEmpty()) {
        LogQuene_local.push(logQuene.getQuene());
        sessionStorage.removeItem("pelog");
    }
    // $NCPE.commit();
});



export default $NCPE;
